import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-home-delivery',
  templateUrl: './our-home-delivery.component.html',
  styleUrls: ['./our-home-delivery.component.scss']
})
export class OurHomeDeliveryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
